export default {
    domain: localStorage.getItem('domain'),
}
